import styled from 'styled-components';

export const StyledGhostVipBadge = styled.div`
  border-radius: 16px;
  border: 1px solid #6701e1;
  background: #000;
  width: 48px;
  height: 14px;
  display: flex;
  align-items: center;
  margin-right: 4px;

  .badge {
    height: 16px;
    width: auto;
    left: -2px;
    position: relative;
  }
`;
